export default "__VITE_ASSET__BZYbERN1__"